<template>
    <div class="serviceview-layout">
      <div class="serviceview-header">
        <navbar classname="home"></navbar>
        <Serviceheader></Serviceheader>
      </div>
      <div class="serviceview-main">
        <Servicemain></Servicemain>
   
      </div>
      <div class="serviceview-footer">
        <Otherfooter ></Otherfooter>
      </div>
    </div>
  </template>
  <script setup>
  import Otherfooter from "@/components/otherfooter.vue";
  import navbar from "@/components/navbar.vue";
  import Serviceheader from "@/views/homeview/serviceadvantage/serviceheader.vue";
  import Servicemain from "@/views/homeview/serviceadvantage/servicemain.vue";
  import Productcontent from "@/views/productservice/productcontent.vue";
  import Productintroduce from "@/views/productservice/productintroduce.vue";
  </script>
  <style lang="scss" scoped>
  // @import "@/assets/scss/theme.scss";
  
  .serviceview-layout {
    background: #f7f7f7;
    // margin: 0 auto;
    width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
    @media screen and (max-width: 768px) {
      // background-color: skyblue;
    }
    @media screen and (min-width: 769px) and (max-width: 1200px) {
      // background-color: pink;
    }
    @media screen and (min-width: 1201px) and (max-width: 2600px) {
      // background-color: yellow;
      // 头部样式
      .serviceview-header {
        width: 100%;
        margin: 0 auto;
        height: 620px;
        box-sizing: border-box;
        // background-color: yellow;
        // width: 88%;
        // margin: 0 auto;
        background: #000 url(@/assets/image/homeview/ggrid2.png) no-repeat
          center;
        //   background-size: 1920px;
        // z-index: 1; /* 确保内容层位于背景层之上 */
      }
      // 中间内容样式
      .serviceview-main {
        background: var(--web-color-text-white, #FFF);
        // background: #fff;
        width: 100%;
        // height: 743px;
        position: relative;
  
        // top: -150px;
      }
      //尾部样式
      .serviceview-footer {
        background: #fff;
        width: 100%;
        height: auto;
      }
    }
  }
  </style>
  